const careers = () => {

    var thingDone = false,
    n = 0;

    function doThing() {
      const listings = document.querySelectorAll('#rec_job_listing_div ul.rec-job-info');
      if (listings) {
        listings.forEach(function(listing) {
          const listingUrl = listing.querySelector('li.rec-job-title a').getAttribute('href'),
                listingTitle = listing.querySelector('li.rec-job-title a').textContent;
          if(listingUrl && listingTitle) {
            const listingBtn = document.createElement('a'),
                  listingItem = document.createElement('li');
            listingBtn.classList.add('listing-button');
            listingItem.classList.add('listing-button-wrap');
            listingBtn.setAttribute('href', listingUrl);
            listingBtn.setAttribute('target', '_blank');
            listingBtn.setAttribute('title', 'Learn more about the '+listingTitle+' position');
            listingBtn.textContent = 'Learn more';
            listingItem.appendChild(listingBtn);
            listing.appendChild(listingItem);
          }
        })
        thingDone = true;
      }
    }

    const interval = setInterval(function () {
      doThing();
      n++;
      console.log(n);
      
      if (thingDone) {
        clearInterval(interval);
      }
    }, 500);

}

export default careers;